import Yup from '~/util/yup';

export function getCustomInterventionValidationSchema(maxEndDate: Date): Yup.AnySchema {
	return Yup.object().shape({
		subject: Yup.string().nullable().label('Subject').required(),
		definitionText: Yup.string().nullable().label('Definition Text').required(),
		interventionTypeId: Yup.string().nullable().label('Intervention Type').required(),
		projectedStartDate: Yup.date().label('Start Date').required(),
		projectedEndDate: Yup.date()
			.label('End Date')
			.max(maxEndDate, `Projected end date must come before ${maxEndDate.toLocaleDateString()}`)
			.required(),
		assignedDisciplineId: Yup.string().label('Assigned Discipline').nullable().required()
	});
}
